import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { experimentalStyled } from '@material-ui/core/styles';
import DashboardNavbar from './DashboardNavbar';
import DashboardSidebar from './DashboardSidebar';
import { THEMES } from '../../constants';
import useAuth from '../../hooks/useAuth';
import AnnouncementDialog from './AnnouncementDialog';
import ErrorBoundary from '../../components/common/ErrorBoundary';
import useToggle from '../../hooks/useToggle';
import { Box } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const DashboardLayoutRoot = experimentalStyled('div')(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  display: 'flex',
  height: '100%',
  overflow: 'hidden',
  width: '100%'
}));

const DashboardLayoutContainer = experimentalStyled('div')({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden'
});

const DashboardLayoutContent = experimentalStyled('div')({
  flex: '1 1 auto',
  height: '100%',
  overflow: 'auto',
  position: 'relative',
  WebkitOverflowScrolling: 'touch'
});

const DashboardLayout = () => {
  // eslint-disable-next-line no-unused-vars
  const { t, i18n } = useTranslation();
  const [isSidebarMobileOpen, setIsSidebarMobileOpen] = useState(false);
  const { theme } = useAuth();
  const [collapsed, { toggle }] = useToggle();

  return (
    <>
      <DashboardLayoutRoot className={theme === THEMES.DARK ? 'tp-root-theme-dark' : 'tp-root-theme-light'}>
        <DashboardNavbar onSidebarMobileOpen={() => setIsSidebarMobileOpen(true)} />
        <DashboardSidebar
          onMobileClose={() => setIsSidebarMobileOpen(false)}
          openMobile={isSidebarMobileOpen}
          collapsed={collapsed}
          toggle={toggle}
        />
        <Box
          sx={{
            display: 'flex',
            flex: '1 1 auto',
            overflow: 'hidden',
            paddingTop: '36px',
            paddingLeft: (the) => ({
              [the.breakpoints.up('lg')]: {
                paddingLeft: collapsed ? '80px' : '250px'
              }
            })
          }}
        >
          <DashboardLayoutContainer>
            <DashboardLayoutContent className="tp-root-container">
              <ErrorBoundary>
                <Outlet />
              </ErrorBoundary>
            </DashboardLayoutContent>
          </DashboardLayoutContainer>
        </Box>
      </DashboardLayoutRoot>
      <AnnouncementDialog />
    </>
  );
};

export default DashboardLayout;
